export enum FileType {
  APK = 'APK',
  SCREENSHOT = 'SCREENSHOT',
  QSA_REPORT = 'QSA_REPORT',
  APP_ICON = 'APP_ICON',
  USER_GUIDE = 'USER_GUIDE',
}
